import React from 'react';
import { TagIcon } from '@heroicons/react/20/solid';

import Sidebar from '@components/Sidebar';

const OnboardingInventory = ({ disabled }) => {
	return (
		<Sidebar.Item to="/unify-onboarding/inventory" disabled={disabled}>
			<TagIcon />
			Inventory
		</Sidebar.Item>
	);
};

export default OnboardingInventory;
